// src/contexts/FormContext.jsx
import React, { createContext, useState } from 'react';

const FormContext = createContext();

export function FormProvider({ children }) {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  
  return (
    <FormContext.Provider value={{ hasUnsavedChanges, setHasUnsavedChanges }}>
      {children}
    </FormContext.Provider>
  );
}

export default FormContext;